/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_DRAFTED_APP: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.boilerplate.privacyPage',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_DRAFTED_APP' },
      },
    },
    GET_DRAFTED_APP: {
      invoke: {
        id: 'getDraftedApp',
        src: 'getDraftedApp',
        onDone: {
          target: 'GET_DRAFTED_DOC',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_DRAFTED_APP_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    GET_DRAFTED_DOC: {
      invoke: {
        id: 'getDraftedDoc',
        src: 'getDraftedDoc',
        onDone: {
          target: 'RENDER_DRAFTED_APP',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_DRAFTED_APP_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_DRAFTED_APP: {
      on: {
        START: { target: 'GET_DRAFTED_APP' },
      },
    },
    RENDER_DRAFTED_APP_ERROR: {
      on: {
        START: { target: 'GET_DRAFTED_APP' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
